import { render, staticRenderFns } from "./safetyCheckAppr.vue?vue&type=template&id=c24495e0"
import script from "./safetyCheckAppr.vue?vue&type=script&lang=js"
export * from "./safetyCheckAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24495e0')) {
      api.createRecord('c24495e0', component.options)
    } else {
      api.reload('c24495e0', component.options)
    }
    module.hot.accept("./safetyCheckAppr.vue?vue&type=template&id=c24495e0", function () {
      api.rerender('c24495e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/min/safetyCheckAppr.vue"
export default component.exports